import { Component, OnInit,Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ApiService } from '../../../../../../Services/api.service';
import { StorageService } from '../../../../../../Services/storage.service';
import { SweetAlert } from '../../../../../../Services/sweetalet.service';
declare const Swal;

@Component({
  selector: 'app-unassign-driver',
  templateUrl: './unassign-driver-component.html',
  
})
export class UnAssignDriverComponent implements OnInit {
  @Input() _activeMenu: string = '';
  @Input() public set search(val: string) {
      this.onSearchChange(val);
  }

  public vendorID = '';
  public manageData = [];

  public filterTable:boolean = true;
  public enableTable:boolean = false;
  isClicked: boolean = false;
  /* Pagination */
  public showPagination:boolean = true;
  public paginationData = {
    page:1,
    limit:10,
    totalPage:1,
  };

  /* filters */
  searchChangeObserver: any;
  public searchInputValue = '';
  public branchNameMap: { [key: string]: string } = {};

  public cols = [
    { key: '#', display: '#' },
    { key: 'name', display: 'Name ', },
    { key: 'mobile', display: 'Mobile number',headerConfig:{ isDefault: true}},
    { key: 'branch', display: 'Branch' },
    { key: 'shift', display: 'Shift' },

    // { key: 'action', display: 'Action', 
    //   config: { 
    //     isAction: true,
    //     actions: [
    //       { display: 'Update', color: 'primary', icon: 'Edit', class:'fs-13' },
    //       { display: 'Delete', color: 'warn', icon: 'Delete' },
    //     ]
    //   }
    // }
  ];
  public tableData = [];
  public unAssignDrivertableData=[];
  
  constructor(
    public storage: StorageService, 
    public router: Router,
    public route: ActivatedRoute,
    public api: ApiService,
    public swal :SweetAlert,
) {
  this.route.paramMap.subscribe((params: any) => {
    this.vendorID=params.params.vendorID;
  });
}

  ngOnInit(): void {
    this.getBranchList();
    setTimeout(()=>{ this.getManageList(); },1000);
  }

  getBranchList() {
    const obj = {
      orgID: this.storage.get('userInfo').orgID
    };

    this.api.transportManagerBranchList(obj).then((res: any) => {
      if (res?.status === 'success' && Array.isArray(res.data)) {
        this.branchNameMap = {};
        res.data.forEach(branch => {
          if (branch?.branchID) {
            this.branchNameMap[String(branch.branchID)] = branch.branchName || branch.branchID;
          }
        });
        this.remapTableBranchValues();
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  normalizeList(value: any): any[] {
    if (value === null || value === undefined || value === '') {
      return [];
    }

    if (Array.isArray(value)) {
      return value;
    }

    if (typeof value === 'string' && value.includes(',')) {
      return value.split(',').map(item => item.trim()).filter(item => item !== '');
    }

    return [value];
  }

  extractBranchToken(branch: any): string {
    if (branch === null || branch === undefined) {
      return '';
    }

    if (typeof branch === 'object') {
      return String(
        branch.branchID ??
        branch.branch ??
        branch.branchName ??
        branch.value ??
        branch.name ??
        ''
      ).trim();
    }

    return String(branch).trim();
  }

  formatBranchValue(item: any): string {
    const rawBranches = item?.branchName ?? item?.branch ?? item?.branchID;
    const branches = this.normalizeList(rawBranches)
      .map(branch => {
        const key = this.extractBranchToken(branch);
        return this.branchNameMap[key] || key;
      })
      .filter(branch => branch && branch !== 'undefined' && branch !== 'null');

    return branches.length > 0 ? branches.join(', ') : '---';
  }

  remapTableBranchValues() {
    if (!Array.isArray(this.unAssignDrivertableData) || this.unAssignDrivertableData.length === 0) {
      return;
    }

    this.unAssignDrivertableData = this.unAssignDrivertableData.map(item => ({
      ...item,
      branch: this.formatBranchValue(item)
    }));
  }

  getManageList(page=1,limit=10,name?){
    this.enableTable = false;
    const obj = {
      vendorID: this.vendorID == null ? this.storage.get('vendorID_orgID').vendorID : this.vendorID,
      page:page,
      limit:limit,
    };
    if(name && name!="") obj['name'] = name ? name : this.search;
    
  
    this.api.transportManagerUnassignDriverList(obj).then((res: any) => {
        if (res.status == 'success') {
          if(res.data){
            this.unAssignDrivertableData = res.data.map(item => ({
              ...item,
              branch: this.formatBranchValue(item)
            }));
          } 
          this.processPagination(res,obj);      
        }
        setTimeout(()=>{ this.enableTable = true;},200);
      }).catch((err) => {
        console.log(err);
      });
  
    

  }


  
  processPagination(data,req){
    this.enableTable = false;
    this.paginationData = {
      page:req.page,
      limit:req.limit,
      totalPage: this.getTotalCount(data.totCnt,req.limit),
    }
    this.enableTable = true;
  }

  getTotalCount(total,limit){
    let result:any = 1;  
    if(total/limit>0){
      result = total / limit;
      if(total % limit > 0) result++;
    }
    return Math.floor(result);
  }

  pagination(data){
    this.getManageList(data.page,data.limit,this.searchInputValue);
  }

     // search
     onSearchChange(searchValue: string) {

      searchValue = searchValue.trim().replace(/[^a-zA-Z0-9-_&, ]/g, '');
  
      if (!this.searchChangeObserver) {
        new Observable(observer => {
          this.searchChangeObserver = observer;
        }).pipe(debounceTime(500)) // wait 300ms after the last event before emitting last event
          .pipe(distinctUntilChanged()) // only emit if value is different from previous value
          .subscribe((term: any) => {
            // your code here
            this.searchInputValue = term;
            if(String(term).length==0) this.getManageList(1,this.paginationData.limit,term);
            else if(String(term).length>=2) this.getManageList(1,this.paginationData.limit,term);
            
          });
      }
  
      this.searchChangeObserver.next(searchValue);
    }

}
